import getUserInfo from '@/common/utils/getUserInfo'
import { App_User } from '@/data/user_info'

export default {
    methods: {
        addConsultant (e) {
            getUserInfo(e, () => {
                App_User.is_consultant().then((is_consultant) => {
                    wx.navigateTo({
                        url: is_consultant ? '/packageA/consultant_task/main' : '/personal_package/add_consultant/main'
                    })
                })
            }, '需要认证用户信息才可以入驻置业顾问')
        }
    }
}
